import { Application } from "./Application";

export function app() {
    return Application.instance;
}

